import React from "react";
import classes from "./Button.module.css";
export default function Button(props) {
  return (
    <button
      type={props.type}
      onClick={props.onClick}
      style={props.style}
      className={`${classes.button} ${props.class ? props.class : ""}`}
      disabled={props.disabled}
    >
      {props.children}
    </button>
  );
}
